import React, {useEffect, useState} from "react";
import {collection, doc, getDoc, getDocs, query, where} from "firebase/firestore";
import {db} from "../../index";
import {useNavigate, useParams} from "react-router-dom";
import Spinner from "../../spinner";
import Cookies from "js-cookie";


const LomdimLogin = () => {

    const params = useParams();
    const [sium, setSium] = useState([]);
    const [lomedId, setLomedId] = useState('');
    const [loadingButton, setLoadingButton] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [isAdmin, setIsAdmin] = React.useState(false);
    const navigate = useNavigate();

    const ButtonWithSpinner = ({ isLoading, children, ...props }) => (
        <button {...props} disabled={isLoading || props.disabled}>
            {isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : children}
        </button>
    );

    function displayToastMsg(msg) {
        setErrorMessage(msg);
        const toastModal = document.getElementById('errorModal');
        const toastBootstrap = window.bootstrap.Toast.getOrCreateInstance(toastModal);
        toastBootstrap.show();
    }

    function handleLomedId() {
        if (lomedId.trim()) {
            setLoadingButton('lomedLogin');
            const lomedIdDigits = lomedId.replace(/\D/g, '');

            const queries = [];

            // Query by phone (digits only)
            if (lomedIdDigits) {
                queries.push(getDocs(query(collection(db, "users"),
                    where("siumId", "==", params.siumId),
                    where("phone", "==", lomedIdDigits)
                )));
            }

            // Query by email
            if (lomedId.includes('@')) {
                queries.push(getDocs(query(collection(db, "users"),
                    where("siumId", "==", params.siumId),
                    where("email", "==", String(lomedId).trim().toLowerCase())
                )));
            }

            Promise.all(queries).then(async (snapshots) => {
                for (const snapshot of snapshots) {
                    for (const userDoc of snapshot.docs) {
                        const link =  (sium.haluka && sium.haluka == 'dapim') ? '/updateStatusDapim/' + userDoc.id : '/updateStatus/' + userDoc.id;
                        navigate(link);
                        return;
                    }
                }

                setLoadingButton(null);
                displayToastMsg('לא נמצא לומד עם הפרטים שהוזנו');
            }).catch(e => {
                console.error("Error finding user: ", e);
                setLoadingButton(null);
                displayToastMsg('אירעה שגיאה בחיפוש הלומד');
            });
        }
    }

    useEffect(() => {
        const docRef = doc(db, "siumim", params.siumId);
        getDoc(docRef).then(siumRef => {
            if (siumRef && siumRef.exists()) {
                setSium(siumRef.data());
                const isAdmin = Cookies.get('siumShasId') === siumRef.id;
                setIsAdmin(isAdmin);
            } else {
                navigate("/");
            }

        });
    },[params.siumId]);

    if (sium && sium.kehilaName) {
        return (
            <div className="sium-main">
                <div className="sium-main-container">
                    <div className="basad-with-return">
                        <div className="basad">
                            <span>בס"ד</span>
                            <br/>
                            <span>להצלחת עם ישראל</span>
                        </div>
                        {isAdmin && <div className="return-container">
                            <a className="btn sium-button return-button"
                               href={"/niulSium/" + params.siumId + "/siumStatus"}>חזור</a>
                        </div>}
                    </div>
                    <div className="sium-logo">
                        <a className="sium-logo-img" href="/" aria-label="Home page" role="link"></a>
                    </div>
                    <div
                        className="grid p-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3 sium-titles">
                        <h2>סיום הש"ס של {sium.kehilaName}</h2>
                        <h4>כניסה ללומדים</h4>
                        {sium.logo && <div alt="logo" className={sium.logo}/>}
                    </div>
                    <div className="lomdim-login-content">
                        <div className="input-row">
                            <div className="input-container">
                                <input
                                    type="text"
                                    value={lomedId}
                                    className="input"
                                    onChange={(e) => setLomedId(e.target.value)}
                                    placeholder="אימייל או פלאפון"
                                    name="lomedId"
                                />
                            </div>
                            <div className="input-container">
                                <ButtonWithSpinner
                                    className="btn new-sium-button send-forgot-id dark-button"
                                    onClick={() => handleLomedId()}
                                    isLoading={loadingButton === 'lomedLogin'}
                                >
                                    כניסה ללומד
                                </ButtonWithSpinner>
                            </div>
                        </div>
                    </div>
                    <div className="toast-container position-fixed top-0 start-50 translate-middle-x">
                        <div id="errorModal" className="toast" role="alert" aria-live="assertive"
                             aria-atomic="true" data-bs-autohide="true" data-bs-delay="3000">
                            <button type="button" className="btn-close me-2 m-auto" data-bs-dismiss="toast"
                                    aria-label="Close"></button>
                            <div className="toast-body">
                                {errorMessage}
                            </div>
                        </div>
                    </div>
                    <div className="sium-bottom-page">
                        <span> © כל הזכויות שמורות לאתר סיום הש"ס</span>
                    </div>
                </div>
            </div>
        )
    } else {
        return (<Spinner/>);
    }

}
export default LomdimLogin;
